import script from "./AuthWall.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthWall.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/modules/AuthWall.css?vue&type=style&index=0&id=8d867684&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d867684"]])

export default __exports__